import {
  faDiagramNested,
  type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export const MENTION_ICONS = {
  diagramNested: faDiagramNested,
} as const satisfies Record<string, IconDefinition>;

export type MentionIconKey = keyof typeof MENTION_ICONS;

export const resolveMentionIcon = (
  key: string | undefined,
): IconDefinition | undefined => {
  if (!key) return undefined;
  if (key in MENTION_ICONS) return MENTION_ICONS[key as MentionIconKey];
  return undefined;
};
